import React from 'react';
import MainComponent from './components/MainComponent';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <MainComponent />
    </div>
  );
}

export default App;
